"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _EcommerceStoreStats = _interopRequireDefault(require("./EcommerceStoreStats"));

var _default =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(_default, _Record);

  function _default() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, _default);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(_default).call(this, (0, _extends2.default)({}, data, {
      import: new _immutable.Map(data.import),
      counts: new _EcommerceStoreStats.default(data.counts),
      workflows: new _immutable.Map(data.workflows)
    })));
  }

  return _default;
}((0, _immutable.Record)({
  applicationIconUrl: null,
  storeToken: null,
  import: new _immutable.Map(),
  counts: new _EcommerceStoreStats.default(),
  workflows: null
}, 'EcommerceStoreDetails'));

exports.default = _default;
module.exports = exports.default;